import { EventEmitter } from '@angular/core';
import { CampaignInfluencerStatus, ChannelStatus, FacebookAuthPreviousState, platformIconPath } from '../../../app.constants';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { AppSettings } from '../../../utils/app-settings';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { AuthService } from '../../../core/auth.service';
import { ActivatedRoute } from '@angular/router';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { saveAs as saveAs } from 'file-saver';
var CampaignDetailsComponent = /** @class */ (function () {
    function CampaignDetailsComponent(influencerService, campaignService, modalService, userService, auth, activatedRoute, translate) {
        this.influencerService = influencerService;
        this.campaignService = campaignService;
        this.modalService = modalService;
        this.userService = userService;
        this.auth = auth;
        this.activatedRoute = activatedRoute;
        this.translate = translate;
        this.isDeletedOrError = false;
        this.openContactEvt = new EventEmitter();
        this.declineCallback = new EventEmitter();
        this.acceptInvitation = new EventEmitter();
        this.showDeclineModal = false;
        this.listExistingChannel = [];
        this.isFbAuthFail = false;
    }
    CampaignDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var currentInfluencer = this.userService.getInfluencerInfo();
        if (currentInfluencer) {
            this.loadInfluencerChannels(currentInfluencer.id);
        }
        this.activatedRoute.queryParams.subscribe(function (params) {
            if (params.error) {
                _this.isFbAuthFail = true;
            }
        });
    };
    CampaignDetailsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var localChannelAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
        if (localChannelAuthData) {
            this.modalService.openInCenter(this.AcceptCampaignPopup, null, 'campaign-confirm-popup');
            // remove the local auth data
            this.auth.removeInfluencerChannelAuthorizationLocalData();
        }
        this.confirmInfluencerNameAndEmailSubscription = this.influencerService.confirmInfluencerNameAndEmailObserver
            .subscribe(function (res) {
            _this.isConfirmingInfluencerNameAndEmail = res;
        });
    };
    CampaignDetailsComponent.prototype.ngOnDestroy = function () {
        if (this.confirmInfluencerNameAndEmailSubscription) {
            this.confirmInfluencerNameAndEmailSubscription.unsubscribe();
        }
    };
    CampaignDetailsComponent.prototype.loadInfluencerChannels = function (influencerId) {
        var _this = this;
        this.influencerService.getInfluencerChannels(influencerId).subscribe(function (res) {
            _this.listExistingChannel = res;
            var igChannels = _this.listExistingChannel.filter(function (ec) { return ec.platform.id === platformIconPath.instagram.id; });
            if (igChannels.length > 0) {
                var channelAuthData_1 = _this.auth.getInfluencerChannelAuthorizationLocalData();
                igChannels.forEach(function (cn) {
                    if (channelAuthData_1 && cn.id === channelAuthData_1.activeChannelId && _this.isFbAuthFail) {
                        cn.type = ChannelStatus.AUTHORIZE_FAILED;
                    }
                    else if (!_this.auth.hasAuthorizedIgChannel(cn.id)) {
                        // force to influencer always to authorize the ig channel before accepting to get the updated auth token
                        cn.type = ChannelStatus.UNAUTHORIZE;
                    }
                });
            }
        });
    };
    CampaignDetailsComponent.prototype.isPdfFile = function (contentType) {
        return contentType === 'application/pdf';
    };
    CampaignDetailsComponent.prototype.isShowButton = function () {
        return AppSettings.isActiveNewCampaignFlow() && this.isLandingPageMode && this.campaign && !this.isDeletedOrError;
    };
    CampaignDetailsComponent.prototype.onDecline = function () {
        this.showDeclineModal = true;
    };
    CampaignDetailsComponent.prototype.acceptToDecline = function (evt) {
        this.showDeclineModal = false;
        this.declineCallback.emit();
        this.campaign.status = CampaignInfluencerStatus.DELETE;
    };
    CampaignDetailsComponent.prototype.openContact = function () {
        this.openContactEvt.emit();
    };
    CampaignDetailsComponent.prototype.closeDeclineModal = function () {
        this.showDeclineModal = false;
    };
    CampaignDetailsComponent.prototype.clickOutsideDeclineModal = function (evt) {
        if (!evt.target.classList.contains('decline-btn')) {
            this.closeDeclineModal();
        }
    };
    CampaignDetailsComponent.prototype.onAcceptCampaign = function () {
        var hasConfirmedAllChannels = this.listExistingChannel.length > 0
            && this.listExistingChannel.filter(function (cn) { return cn.type !== ChannelStatus.AUTHORIZED; }).length === 0;
        // if already confirmed at least 1 channel, proceed without authorizing channels
        // otherwise, show the popup to require the influencer authorize their channels.
        if (hasConfirmedAllChannels) {
            this.modalService.close();
            this.acceptInvitation.emit();
        }
        else {
            this.modalService.openInCenter(this.AcceptCampaignPopup, null, 'campaign-confirm-popup');
        }
    };
    CampaignDetailsComponent.prototype.onConfirmChannel = function () {
        this.modalService.close();
        this.acceptInvitation.emit();
    };
    Object.defineProperty(CampaignDetailsComponent.prototype, "acceptButtonLabel", {
        get: function () {
            if (!this.listExistingChannel) {
                return this.translate.instant('common.btn.continue');
            }
            if (this.listExistingChannel.length === 0
                || this.listExistingChannel.filter(function (cn) { return cn.type !== ChannelStatus.AUTHORIZED; }).length > 0) {
                return this.translate.instant('common.btn.continue');
            }
            else {
                return this.translate.instant('common.btn.accept');
            }
        },
        enumerable: true,
        configurable: true
    });
    CampaignDetailsComponent.prototype.closeNotification = function () {
        this.modalService.close();
    };
    CampaignDetailsComponent.prototype.checkAuthorizationChannel = function (list) {
        var _this = this;
        var authorizedChannels = [];
        authorizedChannels = list.filter(function (item) { return item.platform.id !== platformIconPath.instagram.id && item.type === ChannelStatus.AUTHORIZED; });
        var igChannels = list.filter(function (item) { return item.platform.id === platformIconPath.instagram.id; });
        if (igChannels && igChannels.length > 0) {
            igChannels.map(function (cn) {
                _this.influencerService.getInfluencerLoginStatus(cn.id).subscribe(function (res) {
                    if (res.status === ChannelStatus.AUTHORIZED) {
                        authorizedChannels.push(cn);
                    }
                    else {
                        return;
                    }
                });
            });
        }
        return authorizedChannels;
    };
    Object.defineProperty(CampaignDetailsComponent.prototype, "activePageBeforeAuthorizingFb", {
        get: function () {
            return FacebookAuthPreviousState.ON_CAMPAIGN_INVITATION;
        },
        enumerable: true,
        configurable: true
    });
    CampaignDetailsComponent.prototype.downloadFile = function (fileData) {
        var campaignFileData = Object.assign({}, fileData, {
            content: fileData.image
        });
        this.campaignService.downloadCampaignMaterials(campaignFileData).subscribe(function (data) {
            if (!data) {
                return;
            }
            else {
                saveAs(data, fileData.name);
            }
        });
    };
    return CampaignDetailsComponent;
}());
export { CampaignDetailsComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaign-new/campaign-details/campaign-details.component.ts.pre-build-optimizer.js